import React from 'react';
import { MasterCardIcon, PencilIcon, VisaIcon, DinersClubIcon, MagnaIcon, RedcompraIcon, CardIcon } from '../../@theme/assets/svg/icons';
import Button from '../Button';
import { ButtonContainer, ChipCard, CreditInfoContainer, IconContainer, PortalContainer, TextContainer, AmericanExpressIconStyled as AmericanExpressIcon } from './styles/PortalCardStyled';
import { colors } from '../../@theme/colors';
var kindOfCard = {
  debit: {
    name: 'DÉBITO',
    color: colors.NotificacionesVerde
  },
  credit: {
    name: 'CRÉDITO',
    color: colors.NotificacionesAmarilloHover
  },
  prepaid: {
    name: 'PREPAGO',
    color: colors.NotificacionesAzul
  },
  "default": undefined
};
var brands = {
  visa: React.createElement(VisaIcon, null),
  mastercard: React.createElement(MasterCardIcon, null),
  americanexpress: React.createElement(AmericanExpressIcon, null),
  magna: React.createElement(MagnaIcon, null),
  diners: React.createElement(DinersClubIcon, null),
  prepago: React.createElement(RedcompraIcon, null),
  redcompra: React.createElement(RedcompraIcon, null),
  "default": React.createElement(CardIcon, null)
};
var PortalCard = function PortalCard(_ref) {
  var variant = _ref.variant,
    cardNumbers = _ref.cardNumbers,
    handleEdit = _ref.handleEdit,
    favorite = _ref.favorite,
    brand = _ref.brand,
    canEdit = _ref.canEdit;
  var buttonSX = {
    textTransform: 'none',
    padding: '6px 8px 6px 12px',
    gap: '8px',
    maxHeight: '32px',
    alignSelf: 'end',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '18px'
  };
  var kind = kindOfCard[variant || 'default'];
  return React.createElement(PortalContainer, null, React.createElement(IconContainer, null, brands[brand], kind && React.createElement(ChipCard, {
    favorite: favorite,
    variant: kind.color
  }, kind.name)), React.createElement(CreditInfoContainer, null, React.createElement(TextContainer, null, React.createElement("span", null, "N\xFAmero de tarjeta"), React.createElement("span", null, "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ".concat(cardNumbers))), canEdit && React.createElement(ButtonContainer, null, React.createElement(Button, {
    sx: buttonSX,
    variant: "outlined",
    color: "corporate",
    onClick: handleEdit
  }, "Editar", React.createElement(PencilIcon, null)))));
};
export default PortalCard;